import styled from 'styled-components';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { Icon } from '@components/icon';

export const Container = styled(Grid).attrs({
  container: true,
  component: 'main',
  sx: { height: '100vh' },
})``;

export const Square = styled(Box).attrs({
  width: 20,
  bgcolor: 'white.dark',
  flex: 1,
  flexDirection: 'column',
})``;

export const LogoWrapper = styled(Box).attrs({
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  bottom: 0,
  right: 0,
  mb: 5,
  mr: 8,
})``;

export const Wrapper = styled(Box).attrs({
  position: 'absolute',
  bottom: 0,
  right: 0,
})``;

export const LeftContent = styled(Grid).attrs({
  xs: false,
  sm: 4,
  md: 7,
  container: true,
  alignContent: 'center',
  justifyContent: 'center',
  position: 'relative',
})`
  background: ${({ theme }) => theme.gradients.primary};
`;

export const RightContent = styled(Grid).attrs({
  item: true,
  xs: 12,
  sm: 8,
  md: 5,
  container: true,
  direction: 'row',
  justifyContent: 'center',
  alignItems: 'center',
})``;

export const Form = styled(Box).attrs({
  my: 8,
  mx: 4,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  maxWidth: 521,
})``;

export const InsightsIcon = styled(Icon).attrs({
  name: 'insights',
  alt: 'Insights Icone',
})<any>`
  width: 18rem;
`;

export const LogoIcon = styled.img.attrs(({ theme }) => ({
  src: theme.media.logos.main,
  alt: 'Logo Icone',
}))<any>`
  width: 12rem;
`;

export const UnionIcon = styled(Icon).attrs({
  name: 'union',
  alt: 'Union Icone',
})<any>`
  width: 15rem;
`;

export const Button = styled(ButtonBase).attrs({
  variant: 'contained',
  sx: { mt: 3, mb: 2, fontWeight: 700, fontSize: 16 },
})`
  background: ${({ theme }) => theme.gradients.primary};
  font-family: 'Mukta';
`;

export const SignUpButton = styled(ButtonBase).attrs({
  variant: 'outlined',
  sx: {
    fontFamily: 'Mukta',
    fontSize: 18,
    fontWeight: 700,
    color: 'text.primary',
    border: '1px solid',
    borderColor: (theme: any) =>
      theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.23)',
    px: 5,
    py: 1,
    borderRadius: 1.5,
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      borderColor: 'primary.main',
      color: 'primary.main',
      bgcolor: (theme: any) =>
        theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.04)',
    },
  },
})``;

export const UnderlineButton = styled(ButtonBase).attrs({
  sx: {
    textDecoration: 'underline',
    color: 'text.secondary',
    fontSize: 14,
    '&:hover': {
      color: 'text.primary',
    },
  },
})``;

export const ButtonWrapper = styled(Box).attrs({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  alignItems: 'center',
})``;

export const ModalContainer = styled(Box).attrs({
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
})`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const ModalContent = styled(Box)`
  overflow: hidden;
  overflow-y: scroll;
  scrollbar-width: none;
  box-sizing: content-box;
  max-height: 500px;
  max-width: 700px;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Description = styled(Typography).attrs({
  variant: 'h6',
  fontFamily: 'Mukta',
  fontWeight: 400,
  color: 'text.secondary',
})``;
